<div class="container-fluid">
    <div class="row">
        <div class="col-md-3" *ngIf="showSideMenu">
            <a routerLink="/naac/dvv/criteria1"> <i class="fas fa-long-arrow-alt-left"></i> Go Back</a>
            <nav id="secondary-navigation">
                <!-- Header -->
                <header class="header">
                    <h5>1.2.1</h5>
                </header>
                <!-- /Header -->
                <ul>
                    <li class="one">
                        <a (click)="changeRoute('1')">1.2.1.1 Certificate from Head of the Institute</a>
                    </li>
                    <li class="two">
                        <a (click)="changeRoute('2')">1.2.1.2_Summary report of add-on courses</a>
                    </li>
                    <li class="three">
                        <a (click)="changeRoute('3')" >1.2.1.3_Attendance sheet of students of add-on courses</a>
                    </li>
                    <li routerLinkActive="active">
                        <a routerLink="/naac/dvv/criteria1/1-2-1/1-2-1-4" (click)="checkRoute()" (click)="changeRoute('4')" >1.2.1.4_Certificates of Adon Courses</a>
                    </li>
                    <li class="five">
                        <a (click)="changeRoute('5')" >1.2.1.5_Models Certificates</a>
                    </li>
                </ul>
            </nav>
        </div>
        <div [ngClass]="fullWidth ? 'col-md-12' : 'col-md-9'" *ngIf="!showPdf && !showTable">
            <router-outlet></router-outlet>
        </div>

        <div class="col-md-9" *ngIf="showTable">
            <div id="five-one-one">
                <div class="container-fluid">
                  <div class="row">
                    <div class="col-12">
                      <div class="card shadow-lg">
                        <h4 class="card-title text-center" *ngIf="heading3">Attendance sheet of students of add-on courses</h4>
                        <h4 class="card-title text-center" *ngIf="heading4">Models Certificates</h4>
                        <div class="card-body text-justify">
                          <table class="table table-bordered table-hover">
                            <thead>
                              <tr>
                                <!-- <th scope="col">S.NO.</th> -->
                                <th scope="col">TITLE</th>
                                <th scope="col">URL</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let item of result; let i = index;">
                                <!-- <th scope="row">{{i+41}}</th> -->
                                <td class="title">{{item.title}}</td>
                                <td class="link"><a href="{{item.link}}" target="_blank"><i class="fas fa-eye"></i></a> </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
        </div>

        <div class="col-md-9" *ngIf="showPdf">
            <div class="container-fluid pdf">
                <div class="row">
                    <div class="col-12">
                        <div class="card card-body">
                            <h5 class="card-title text-center" *ngIf="heading1">Certificate from head of the HEI</h5>
                            <h5 class="card-title text-center" *ngIf="heading2">Summary report of add-on courses</h5>
                            <div id="detail" class="text-center">
                                <pdf-viewer [src]="src" [render-text]="true" style="display: block;" id="list-view"></pdf-viewer>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>